<ng-container [formGroup]="formGroupCampaignTypeData">
    <mdb-form-control class="form-fill">
        <app-mdbp-input mdbInput formControlName="eventDetailLink" type="url" label='Event Detail Link (optional)'></app-mdbp-input>
        <mdb-error class="form-fill-error"  *ngIf="formGroupCampaignTypeData.controls.eventDetailLink.hasError('url') && formGroupCampaignTypeData.controls.eventDetailLink.touched ">Please provide valid URL link</mdb-error>
    </mdb-form-control>
    <div class="row justify-content-left">
        <div class="col">
            <app-datetime
                dateLabel="Event Date"
                timeLabel="Event Time"
                [timezone]="formGroupCampaignTypeData.controls.timeZoneData.value.name"
                formControlName="startDateTimeGmtUnix"
                [submitted]="submitted"
                data-panel="eventSettings"
            ></app-datetime>
        </div>
    </div>
    <div class="row">
        <div class="col-6">
            <mdb-form-control class="form-fill" data-panel="eventSettings">
                <app-mdbp-input mdbInput formControlName="duration" [isCurrencyMask]="true" data-panel="eventSettings" label='Duration in minutes'>
                    <input  #inputNameC currencyMask formControlName="duration"  [options]="{ allowNegative: false, prefix: '', inputMode: 1 }" class="form-control form-control--paybee"/>
                </app-mdbp-input>
                <mdb-error class="form-fill-error"  *ngIf="formGroupCampaignTypeData.controls.duration.hasError('required') && formGroupCampaignTypeData.controls.duration.touched ">Please provide Event Duration</mdb-error>
                <mdb-error class="form-fill-error"  *ngIf="formGroupCampaignTypeData.controls.duration.hasError('min') && formGroupCampaignTypeData.controls.duration.touched ">Duration should not be less than 1 mins</mdb-error>
                <mdb-error class="form-fill-error"  *ngIf="formGroupCampaignTypeData.controls.duration.hasError('max') && formGroupCampaignTypeData.controls.duration.touched ">Duration should be less than 1440 mins</mdb-error>
            </mdb-form-control>
        </div>
        <div class="col-6" formGroupName="timeZoneData">
            <mdb-form-control class="form-fill">
                <mdb-select formControlName="name" class="mdb-select" [filter]="true">
                  <mdb-option *ngFor="let timeZone of timeZoneList" [value]="timeZone.value">{{
                    timeZone.label
                  }}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label form-label--paybee">Time Zone</label>
              </mdb-form-control>
        </div>
    </div>
</ng-container>